<div class="page-container">
	<nz-result nzStatus="500" nzTitle="500" nzSubTitle="{{ 'error.internal-server-error' | translate }}">
		<div nz-result-extra>
			<button nz-button nzType="primary" (click)="navigateBack()">
				{{ 'error.back-to-previous-page' | translate }}
			</button>
		</div>
	</nz-result>
</div>
